import React, { useState, useEffect } from 'react';
import { GoogleLogin, googleLogout } from '@react-oauth/google';

// const visai_server = "http://bps-pc.tail1c1f81.ts.net:5001"; // Replace with your actual server address
// const rareml_backend_server = "https://rareml-backend-dot-gen-lang-client-0537550558.ew.r.appspot.com"
// const rareml_backend_server = "https://rareml-backend-781395418590.europe-west1.run.app";
const rareml_backend_server = "/api/proxy/backend";

const nationalityOptions = [
  { value: 'India', label: 'India' },
  // { value: 'USA', label: 'USA' },
  // { value: 'UK', label: 'UK' },
  // { value: 'Canada', label: 'Canada' },
  // Add more nationalities as needed
];

const countryVisaOptions = [
  {
    country: 'Germany',
    visas: ['Tourist', 'Student', 'Business', 'Work']
  },
  {
    country: 'UK',
    visas: ['Tourist', 'Student', 'Business', 'Work']
  },
  {
    country: 'Canada',
    visas: ['Tourist', 'Student', 'Business', 'Work']
  },
  // Add more countries and visa types as needed
];

const VisaAgent = () => {
  const [sessionId, setSessionId] = useState(null); // Generate a unique session ID based on timestamp
  const [loadingSession, setLoadingSession] = useState(false);
  const [userId, setUserId] = useState(null);
  const [showGoogleLogin, setShowGoogleLogin] = useState(false);
  const [loadingGoogleLogin, setLoadingGoogleLogin] = useState(false);

  // State for application details table and step 4
  const [applicationDetails, setApplicationDetails] = useState(null);
  const [step, setStep] = useState(1);
  // Track file input refs and tooltip open states for each doc row
  const inputRefs = React.useRef([]);
  const [tooltipOpenArr, setTooltipOpenArr] = useState([]);
  // Track which reason info icon is hovered for tooltip
  const [hoveredReasonIdx, setHoveredReasonIdx] = useState(null);
  const [selectedNationality, setSelectedNationality] = useState(nationalityOptions[0].value);
  const [selectedCountry, setSelectedCountry] = useState(countryVisaOptions[0].country);
  const [selectedVisa, setSelectedVisa] = useState(countryVisaOptions[0].visas[0]); // Default to first visa type of the first country
  const [loadingRequirements, setLoadingRequirements] = useState(false);
  const [loadingApplicationDetails, setLoadingApplicationDetails] = useState(false);

  const [uploads, setUploads] = useState({});
  // Track submitting state per document
  const [submittingDoc, setSubmittingDoc] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [uploadResponseMsg, setUploadResponseMsg] = useState(null);
  const [error, setError] = useState(null); // Add error state

  const [applicationFormData, setApplicationFormData] = useState(null);
  const [loadingApplicationForm, setLoadingApplicationForm] = useState(false);


  const handleDownloadApplication = () => {
    if (!applicationFormData) return;
    const blob = new Blob([JSON.stringify(applicationFormData, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'application_form.json';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const handleApplicationGeneration = async () => {
    setLoadingApplicationForm(true);
    setError(null);
    try {
      const response = await fetch(`${rareml_backend_server}/api/v1/visai/application_generation`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          userId: userId,
          sessionId: sessionId,
          country: selectedCountry,
          visaType: selectedVisa,
          nationality: selectedNationality
        }),
      });
      if (!response.ok) {
        throw new Error('Failed to generate application form');
      }
      const data = await response.json();
      if (!data || !data.result || data.result.length === 0) {
        setError('No application form data found.');
        setLoadingApplicationForm(false);
        return;
      }

      setApplicationFormData(data.result[0]);
      setStep(5);
    } catch (err) {
      setError(err.message || 'Failed to generate application form.');
    }
    setLoadingApplicationForm(false);
  };


  const handleNewSession = async () => {
    setLoadingSession(true);
    setError(null);
    await fetch(`${rareml_backend_server}/api/v1/visai/create_session`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ userId: userId }),
    })
      .then(response => {
        if (!response.ok) {
          return response.text().then(text => {
            throw new Error(text || 'Failed to create session');
          });
        }
        return response.json();
      })
      .then(data => {
        setSessionId(data.sessionId);
        console.log('Session created:', data.sessionId);
        setStep(2); // Proceed to visa selection
      })
      .catch(error => {
        setError(error.message || 'Failed to create session.');
        console.error('Error creating session:', error);
      })
      .finally(() => {
        setLoadingSession(false);
      });
  }

  const handleNationalityChange = (e) => {
    setSelectedNationality(e.target.value);
    setSelectedCountry('');
    setSelectedVisa('');
    setUploads({});
  }

  const handleCountryChange = (e) => {
    setSelectedCountry(e.target.value);
    setSelectedNationality('');
    setSelectedVisa('');
    setUploads({});
  };

  const handleVisaChange = (e) => {
    setSelectedVisa(e.target.value);
    setUploads({});
  };


  const handleApplicationDetails = async () => {
    setLoadingApplicationDetails(true);
    setError(null);
    // invoke /application_summary endpoint
    try {
      const response = await fetch(`${rareml_backend_server}/api/v1/visai/application_summary`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          userId: userId,
          sessionId: sessionId,
          country: selectedCountry,
          visaType: selectedVisa,
          nationality: selectedNationality
        }),
      });
      if (!response.ok) {
        throw new Error('Failed to fetch application details');
      }
      const data = await response.json();
      if (!data || !data.result || data.result.length === 0) {
        setError('No application details found. Please ensure you have selected a country and visa type.');
        setLoadingApplicationDetails(false);
        return;
      }
      setApplicationDetails(data.result);
      setStep(4);
    } catch (error) {
      console.error('Error fetching application details:', error);
    }
  };

  const handleVisaRequirements = async () => {
    setLoadingRequirements(true);
    setError(null);
    try {
      const response = await fetch(`${rareml_backend_server}/api/v1/visai/visa-requirements`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          userId: userId,
          sessionId: sessionId,
          country: selectedCountry,
          visaType: selectedVisa,
          nationality: selectedNationality
        }),
      });
      if (!response.ok) {
        throw new Error('Failed to fetch visa requirements');
      }
      const data = await response.json();
      const visaRequirements = data.result;
      if (!visaRequirements || visaRequirements.length === 0) {
        setError('No visa requirements found for the selected country and visa type.');
        setLoadingRequirements(false);
        return;
      }
      setDocList(visaRequirements); // Set to array of requirement objects
      setStep(3);
    } catch (err) {
      setError('Failed to fetch visa requirements. Please try again.');
      console.error('Error:', err);
    }
    setLoadingRequirements(false);
  };

  const handleFileChange = (docName, file, inputRef) => {
    // Always trigger validation for reuploads, even if file is same
    setUploads(prev => ({ ...prev, [docName]: file }));
    setSubmitted(false);
    setUploadResponseMsg(null);
    if (file) {
      setSubmittingDoc(docName);
      // Reset file input value so reuploads always trigger
      if (inputRef && inputRef.current) {
        inputRef.current.value = '';
      }
      setTimeout(() => {
        handleSingleUpload(docName, file);
      }, 50);
    }
  };

  // New: handle single document upload and update docList
  const handleSingleUpload = async (docName, file) => {
    // setSubmitting(true); // replaced by setSubmittingDoc above
    setError(null);
    try {
      const formData = new FormData();
      formData.append('userId', userId);
      formData.append('sessionId', sessionId);
      formData.append('country', selectedCountry);
      formData.append('visaType', selectedVisa);
      formData.append('nationality', selectedNationality);
      // Only send the specification for the current doc
      const doc = docList.find(d => d.value === docName);
      const docSpec = doc ? `artifact_name: ${doc.value} | artifact_specification: ${doc.specifications || 'No specifications provided'}` : '';
      formData.append('documentSpecifications', docSpec);
      formData.append('documents', file, docName);
      const response = await fetch(`${rareml_backend_server}/api/v1/visai/upload`, {
        method: 'POST',
        body: formData,
      });
      if (!response.ok) {
        let errMsg = 'Failed to submit application';
        try {
          const errData = await response.json();
          if (errData && errData.error) errMsg = errData.error;
        } catch {}
        throw new Error(errMsg);
      }
      setSubmitted(true);
      const data = await response.json();
      const result = data.result;
          // if result is empty list, ask to retry
          if (!result || result.length === 0) {
            setError('No scoring results found for the uploaded document. Please try again.');
            setSubmittingDoc(null);
            return;
          }
          // if result contains a single empty object, ask to retry
          if (result.length === 1 && Object.keys(result[0]).length === 0) {
            setError('No scoring results found for the uploaded document. Please try again.');
            setSubmittingDoc(null);
            return;
          }
      // Only update the relevant doc in docList
      const updatedDocList = docList.map(doc => {
        if (doc.value === docName) {
          const matchingResult = result.find(item => item.artifact_name === doc.value);
          if (matchingResult) {
            return {
              ...doc,
              score: matchingResult.total_score,
              details: matchingResult.scores
            };
          }
        }
        return doc;
      });
      setDocList(updatedDocList);
      setSubmittingDoc(null); // Ensure button returns to 'Upload' after validation
      // setUploadResponseMsg('Document uploaded and validated!');
    } catch (err) {
      setError(err.message || 'Submission failed. Please try again.');
      console.error('Submission error:', err);
      setSubmittingDoc(null);
    }
  };
  const [docList, setDocList] = useState([]);

  // Progress calculation
  const uploadedCount = Array.isArray(docList) ? docList.filter(doc => uploads[doc.value]).length : 0;
  const progress = Array.isArray(docList) && docList.length ? Math.round((uploadedCount / docList.length) * 100) : 0;

  // Ref for requirements view scroll container
  const requirementsScrollRef = React.useRef(null);
  // Ref for inner scrollable div in requirements view
  const requirementsInnerScrollRef = React.useRef(null);

  // Scroll to top when requirements view is shown
  useEffect(() => {
    if (step === 3) {
      if (requirementsScrollRef.current) {
        requirementsScrollRef.current.scrollTop = 0;
      }
      if (requirementsInnerScrollRef.current) {
        requirementsInnerScrollRef.current.scrollTop = 0;
      }
    }
  }, [step, docList]);

  useEffect(() => {
    if (userId) {
      setLoadingGoogleLogin(true);
      // Wait for handleNewSession to finish before disabling loading
      (async () => {
        try {
          await handleNewSession(userId);
        } finally {
          setLoadingGoogleLogin(false);
        }
      })();
    }
  }, [userId]);

  return (
    <div style={{ fontFamily: 'Inter, Arial, sans-serif', background: '#f8fafc', minHeight: '100vh', padding: 40 }}>
      <h1 style={{ fontSize: '2.2rem', fontWeight: 700, color: '#a21caf', marginBottom: 24 }}>
        AI Visa Agent
      </h1>
      <p style={{ fontSize: '1.15rem', color: '#334155', marginBottom: 32 }}>
        Welcome to your AI-powered Visa Application Assistant!<br/>
      </p>
      <div style={{ background: '#fff', borderRadius: 16, boxShadow: '0 4px 24px rgba(30,41,59,0.06)', padding: 32, maxWidth: 600, margin: '0 auto' }}>
        {/* Progress Bar */}
        {/* Step 5: Show download button for application form */}
        {step === 5 && (
          <div style={{ marginTop: 32, textAlign: 'center' }}>
            <h2 style={{ color: '#2563eb', fontWeight: 700, marginBottom: 24 }}>Download Your Application</h2>
            {loadingApplicationForm ? (
              <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#a21caf', fontWeight: 600 }}>
                <svg width="22" height="22" viewBox="0 0 50 50" style={{ marginRight: 8 }}>
                  <circle cx="25" cy="25" r="20" stroke="#a21caf" strokeWidth="5" fill="none" strokeDasharray="31.4 31.4" strokeDashoffset="0">
                    <animateTransform attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.8s" repeatCount="indefinite" />
                  </circle>
                </svg>
                Downloading Application...
              </span>
            ) : applicationFormData ? (
              <>
                <pre style={{
                  textAlign: 'left',
                  background: '#f3f4f6',
                  padding: 16,
                  borderRadius: 8,
                  maxHeight: 320,
                  overflowY: 'auto',
                  fontSize: '0.98em',
                  marginBottom: 24,
                  boxShadow: '0 2px 8px rgba(162,28,175,0.08)'
                }}>
                  {JSON.stringify(applicationFormData, null, 2)}
                </pre>
                <button
                  type="button"
                  className="inspired-btn"
                  style={{ width: '100%' }}
                  onClick={handleDownloadApplication}
                  disabled={loadingApplicationForm}
                >
                  {loadingApplicationForm ? (
                    <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#a21caf' }}>
                      <svg width="22" height="22" viewBox="0 0 50 50" style={{ marginRight: 8 }}>
                        <circle cx="25" cy="25" r="20" stroke="#a21caf" strokeWidth="5" fill="none" strokeDasharray="31.4 31.4" strokeDashoffset="0">
                          <animateTransform attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.8s" repeatCount="indefinite" />
                        </circle>
                      </svg>
                      Downloading Application...
                    </span>
                  ) : 'Download Application'}
                </button>
              </>
            ) : null}
            {error && <div style={{ color: '#dc2626', marginTop: 16 }}>{error}</div>}
          </div>
        )}
        {step === 4 && applicationDetails ? (
        <div style={{ marginTop: 32, textAlign: 'center' }}>
          <h2 style={{ color: '#2563eb', fontWeight: 700, marginBottom: 24 }}>Application Overview</h2>
          <table style={{ margin: '0 auto', minWidth: 340, borderCollapse: 'collapse', boxShadow: '0 2px 8px rgba(162,28,175,0.08)' }}>
            <thead style={{ background: '#f3f4f6' }}>
              <tr>
                <th style={{ padding: '12px 18px', borderBottom: '2px solid #a21caf', fontWeight: 600, fontSize: '1.05rem', color: '#334155', textAlign: 'left' }}>Field</th>
                <th style={{ padding: '12px 18px', borderBottom: '2px solid #a21caf', fontWeight: 600, fontSize: '1.05rem', color: '#334155', textAlign: 'left' }}>Value</th>
              </tr>
            </thead>
            <tbody>
              {applicationDetails.map(({ key, value }, idx) => (
                <tr key={idx} style={{ background: idx % 2 === 0 ? '#fafafc' : '#f3f4f6' }}>
                  <td style={{ padding: '12px 18px', borderBottom: '1px solid #a21caf', fontWeight: 500, color: '#334155', textAlign: 'left' }}>{key}</td>
                  <td style={{ padding: '12px 18px', borderBottom: '1px solid #a21caf', color: '#475569', textAlign: 'left' }}>{value}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <button
            type="button"
            className="inspired-btn"
            style={{ width: '100%', marginTop: 32 }}
            onClick={handleApplicationGeneration}
            disabled={loadingApplicationForm}
          >
            {loadingApplicationForm ? (
              <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#a21caf' }}>
                <svg width="22" height="22" viewBox="0 0 50 50" style={{ marginRight: 8 }}>
                  <circle cx="25" cy="25" r="20" stroke="#a21caf" strokeWidth="5" fill="none" strokeDasharray="31.4 31.4" strokeDashoffset="0">
                    <animateTransform attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.8s" repeatCount="indefinite" />
                  </circle>
                </svg>
                Generating Application...
              </span>
            ) : 'Generate Application'}
          </button>
        </div>
        ) : null}
        {step === 3 && (
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 24 }}>
            <svg width="70" height="70" viewBox="0 0 70 70">
              <circle cx="35" cy="35" r="30" stroke="#e5e7eb" strokeWidth="8" fill="none" />
              <circle
                cx="35" cy="35" r="30"
                stroke="#a21caf"
                strokeWidth="8"
                fill="none"
                strokeDasharray={2 * Math.PI * 30}
                strokeDashoffset={2 * Math.PI * 30 * (1 - progress / 100)}
                strokeLinecap="round"
                style={{ transition: 'stroke-dashoffset 0.5s' }}
              />
              <text x="50%" y="50%" textAnchor="middle" dy=".3em" fontSize="1.2em" fill="#a21caf">{progress}%</text>
            </svg>
          </div>
        )}
        {step === 1 && (
          <div style={{ textAlign: 'left' }}>
            <h2 style={{ color: '#2563eb', fontWeight: 600, marginBottom: 16 }}>How It Works?</h2>
            <ol style={{ color: '#475569', fontSize: '1rem', lineHeight: 1.7 }}>
              <li>Enter your details: destination, nationality and visa type, etc.</li>
              <li>Our Visa Agent does the following for you:
                <ul>
                  <li>Checks which documents are required for your application.</li>
                  <li>Guides you with a step by step process to provide these documents and information.</li>
                  <li>Ensures all provided documents and information are automatically checked to minimize any human errors.</li>
                  <li>Generates a filled application form based on your inputs.</li>
                  <li>Submits this application for you.</li>
                  <li>Schedules an interview appointment for you.</li>
                  <li>Provides you with a downloadable application form.</li>
                </ul>
              </li>
              <li>And that's it! You are ready for your Visa Interview!</li>    
            </ol>
            {!showGoogleLogin ? (
              <button
                className="inspired-btn"
                onClick={() => {
                  setShowGoogleLogin(true);
                }}
                disabled={loadingGoogleLogin || loadingSession}
                style={{ width: '100%', marginTop: 32 }}
              >
                {(loadingGoogleLogin || loadingSession) ? (
                  <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <svg width="18" height="18" viewBox="0 0 50 50" style={{ marginRight: 7 }}>
                      <circle cx="25" cy="25" r="20" stroke="#a21caf" strokeWidth="5" fill="none" strokeDasharray="31.4 31.4" strokeDashoffset="0">
                        <animateTransform attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.8s" repeatCount="indefinite" />
                      </circle>
                    </svg>
                    Processing...
                  </span>
                ) : 'Get Started!'}
              </button>
            ) : (
              <div style={{ marginTop: 32 }}>
                <GoogleLogin
                  onSuccess={credentialResponse => {
                    setLoadingGoogleLogin(true);
                    setUserId(credentialResponse.credential);
                    setShowGoogleLogin(false);
                    // Do NOT setLoadingGoogleLogin(false) here; handled after session creation
                  }}
                  onError={err => {
                    setLoadingGoogleLogin(false);
                    console.log('Login Failed', err)
                    alert('Login Failed');
                  }}
                />
              </div>
            )}
          </div>
        )}
        {/* Removed separate login step, handled in step 1 */}
        {step === 2 && (
            <>
              <h2 style={{ color: '#2563eb', fontWeight: 600, marginBottom: 16 }}></h2>
              <div style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '20px',
                alignItems: 'center',
                marginBottom: 24,
                justifyContent: 'space-between',
                maxWidth: 600,
              }}>
                <div style={{ display: 'flex', flexDirection: 'column', minWidth: 160 }}>
                  <label style={{ fontWeight: 500, marginBottom: 8 }}>Nationality</label>
                  <select value={selectedNationality} onChange={handleNationalityChange} style={{ padding: 8, borderRadius: 6, border: '1px solid #a21caf' }}>
                    {nationalityOptions.map(opt => (
                      <option key={opt.value} value={opt.value}>{opt.label}</option>
                    ))}
                  </select>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', minWidth: 160 }}>
                  <label style={{ fontWeight: 500, marginBottom: 8 }}>Destination Country</label>
                  <select value={selectedCountry} onChange={handleCountryChange} style={{ padding: 8, borderRadius: 6, border: '1px solid #a21caf' }}>
                    <option value="">Select Country</option>
                    {countryVisaOptions.map(opt => (
                      <option key={opt.country} value={opt.country}>{opt.country}</option>
                    ))}
                  </select>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', minWidth: 160 }}>
                  <label style={{ fontWeight: 500, marginBottom: 8 }}>Visa Type</label>
                  <select value={selectedVisa} onChange={handleVisaChange} style={{ padding: 8, borderRadius: 6, border: '1px solid #a21caf' }} disabled={!selectedCountry}>
                    <option value="">Select Visa Type</option>
                    {selectedCountry && countryVisaOptions.find(opt => opt.country === selectedCountry).visas.map(type => (
                      <option key={type} value={type}>{type}</option>
                    ))}
                  </select>
                </div>
              </div>
              <button onClick={handleVisaRequirements} className="inspired-btn" disabled={!selectedCountry || !selectedVisa || !selectedNationality || loadingRequirements} style={{ width: '100%', marginTop: 8 }}>
                {loadingRequirements ? (
                  <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <svg width="22" height="22" viewBox="0 0 50 50" style={{ marginRight: 8 }}>
                      <circle cx="25" cy="25" r="20" stroke="#a21caf" strokeWidth="5" fill="none" strokeDasharray="31.4 31.4" strokeDashoffset="0">
                        <animateTransform attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.8s" repeatCount="indefinite" />
                      </circle>
                    </svg>
                    Visa Requirements...
                  </span>
                ) : 'Visa Requirements'}
              </button>
            </>
        )}
        {step === 3 && (
          <>
            <h2 style={{ color: '#2563eb', fontWeight: 600, marginBottom: 16 }}>Required Documents</h2>
            <p style={{ color: '#475569', marginBottom: 16 }}>
              For <b>{selectedCountry}</b> - <b>{selectedVisa}</b> visa, you will need the following documents:
            </p>
            
            <form>
              {Array.isArray(docList) && docList.length > 0 ? (
                <div ref={requirementsScrollRef} style={{ width: '100%', overflowX: 'auto', marginBottom: 24, WebkitOverflowScrolling: 'touch', overflowY: 'auto', maxHeight: 420 }}>
                  <div ref={requirementsInnerScrollRef} style={{ minWidth: 800, position: 'relative', overflowY: 'auto', maxHeight: 420 }}>
                    <div style={{ position: 'absolute', left: 0, right: 0, bottom: 0, height: 16, background: 'transparent', pointerEvents: 'none' }}>
                      <div style={{ width: '100%', height: '16px', background: '#e5e7eb', opacity: 0.5 }}></div>
                    </div>
                    <table style={{ minWidth: 900, borderCollapse: 'collapse', resize: 'horizontal', boxShadow: '0 2px 8px rgba(30,41,59,0.04)' }}>
                    <thead style={{ background: '#f3f4f6' }}>
                      <tr>
                        <th style={{ width: 120, maxWidth: 140, minWidth: 90, borderBottom: '2px solid #a21caf', padding: '14px 8px', textAlign: 'left', fontWeight: 600, fontSize: '1rem', letterSpacing: '0.02em' }}>Document</th>
                        <th style={{ width: 320, maxWidth: 400, minWidth: 220, borderBottom: '2px solid #a21caf', padding: '14px 8px', textAlign: 'left', fontWeight: 600, fontSize: '1rem', letterSpacing: '0.02em' }}>Specifications</th>
                        <th style={{ width: 320, maxWidth: 400, minWidth: 220, borderBottom: '2px solid #a21caf', padding: '14px 8px', textAlign: 'left', fontWeight: 600, fontSize: '1rem', letterSpacing: '0.02em' }}>Validation</th>
                      </tr>
                    </thead>
                    <tbody>
                      {docList.map((doc, idx) => {
                        const isUploaded = false; // Always allow upload
                        const isValidating = submittingDoc === doc.value;
                        // Setup file input ref for this row
                        if (!inputRefs.current[idx]) inputRefs.current[idx] = React.createRef();
                        // Setup tooltip open state for this row
                        const tooltipOpen = tooltipOpenArr[idx] || false;
                        const setTooltipOpen = (open) => {
                          setTooltipOpenArr(arr => {
                            const newArr = [...arr];
                            newArr[idx] = typeof open === 'function' ? open(newArr[idx]) : open;
                            return newArr;
                          });
                        };
                        return (
                          <tr key={idx} style={{ background: idx % 2 === 0 ? '#fafafc' : '#f3f4f6' }}>
                            <td style={{ borderBottom: '1px solid #e5e7eb', padding: '14px 8px', fontWeight: 500, fontSize: '1.05rem', color: '#334155', minWidth: 120 }}>
                              {doc.value}
                            </td>
                            <td style={{ borderBottom: '1px solid #e5e7eb', padding: '14px 8px', minWidth: 180, maxWidth: 260, overflow: 'auto' }}>
                              <div style={{ maxHeight: 120, overflowY: 'auto', paddingRight: 4 }}>
                                {doc.specifications
                                  ? doc.specifications
                                      .split(/(?<=\.)\s+/)
                                      .filter(s => s.trim().length > 0)
                                      .map((sentence, i) => (
                                        <div key={i} style={{
                                          background: i % 2 === 0 ? '#f3f4f6' : '#e0e7ff',
                                          padding: '7px 10px',
                                          borderRadius: 6,
                                          marginBottom: 4,
                                          fontSize: '0.98em',
                                          color: '#475569',
                                          lineHeight: 1.5,
                                          fontWeight: 500
                                        }}>{sentence.trim()}</div>
                                      ))
                                  : <div style={{ background: '#f3f4f6', padding: '7px 10px', borderRadius: 6, fontSize: '0.98em', color: '#475569', fontWeight: 500 }}>No specifications provided</div>
                                }
                              </div>
                            </td>
                            <td style={{ borderBottom: '1px solid #e5e7eb', padding: '14px 8px', minWidth: 180, maxWidth: 260, overflow: 'auto', verticalAlign: 'top' }}>
                              <div style={{ maxHeight: 120, overflowY: 'auto', paddingRight: 4 }}>
                                {doc.details ? (
                                  <ul style={{ paddingLeft: 18, margin: 0 }}>
                                    {Object.entries(doc.details).map(([criterion, info], i) => (
                                      <li key={i} style={{ marginBottom: 8, fontSize: '0.98em', color: '#334155', lineHeight: 1.5, position: 'relative' }}>
                                        <span style={{ fontWeight: 500 }}>{criterion}</span><br />
                                        <span style={{ color: info.score === 5 ? '#22c55e' : '#dc2626', fontWeight: 600 }}>Score: {info.score}</span>
                                        {/* Info icon with tooltip for reason */}
                                        <span
                                          style={{ marginLeft: 8, cursor: 'pointer', position: 'relative', display: 'inline-block' }}
                                          onClick={() => setTooltipOpen(open => !open)}
                                          onMouseEnter={() => setHoveredReasonIdx(`${doc.value}-${i}`)}
                                          onMouseLeave={() => setHoveredReasonIdx(null)}
                                        >
                                          {info.score === 5 ? (
                                            // Green check mark
                                            <svg width="15" height="15" viewBox="0 0 20 20" fill="none" style={{ verticalAlign: 'middle' }}>
                                              <circle cx="10" cy="10" r="9" stroke="#22c55e" strokeWidth="2" fill="#fff" />
                                              <polyline points="6,11 9,14 14,7" fill="none" stroke="#22c55e" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                          ) : (
                                            // Red info icon
                                            <svg width="15" height="15" viewBox="0 0 20 20" fill="none" style={{ verticalAlign: 'middle' }}>
                                              <circle cx="10" cy="10" r="9" stroke="#dc2626" strokeWidth="2" fill="#fff" />
                                              <text x="10" y="15" textAnchor="middle" fontSize="13" fill="#dc2626" fontWeight="bold">i</text>
                                            </svg>
                                          )}
                                          {(hoveredReasonIdx === `${doc.value}-${i}` || tooltipOpen) && (
                                            <span
                                              style={{
                                                background: '#fff',
                                                color: '#334155',
                                                textAlign: 'left',
                                                borderRadius: 6,
                                                border: info.score === 5 ? '1px solid #22c55e' : '1px solid #dc2626',
                                                padding: '8px 12px',
                                                position: 'absolute',
                                                zIndex: 10,
                                                left: '22px',
                                                top: '-8px',
                                                minWidth: '180px',
                                                maxHeight: '180px',
                                                overflowY: 'auto',
                                                boxShadow: '0 2px 8px rgba(30,41,59,0.08)',
                                                fontSize: '0.97em',
                                                fontWeight: 500,
                                                cursor: 'pointer'
                                              }}
                                              tabIndex={0}
                                              onClick={e => e.stopPropagation()}
                                            >
                                              {info.reason}
                                            </span>
                                          )}
                                        </span>
                                      </li>
                                    ))}
                                  </ul>
                                ) : <span style={{ color: '#a21caf' }}></span>}
                                {/* Upload button below score details */}
                                <div style={{ marginTop: 10 }}>
                                  <label style={{ display: 'inline-block', position: 'relative' }}>
                                    <input
                                      ref={inputRefs.current[idx]}
                                      type="file"
                                      onChange={e => handleFileChange(doc.value, e.target.files[0], inputRefs.current[idx])}
                                      style={{ display: 'none' }}
                                      disabled={isValidating}
                                    />
                                    <span style={{
                                      display: 'inline-flex',
                                      alignItems: 'center',
                                      background: isValidating ? '#e0e7ff' : '#a21caf',
                                      color: isValidating ? '#a21caf' : '#fff',
                                      padding: '7px 18px',
                                      borderRadius: 7,
                                      fontWeight: 600,
                                      fontSize: '0.98em',
                                      border: 'none',
                                      cursor: isValidating ? 'not-allowed' : 'pointer',
                                      marginRight: 8,
                                      opacity: isValidating ? 0.7 : 1,
                                      boxShadow: isValidating ? 'none' : '0 2px 8px rgba(162,28,175,0.12)',
                                      transition: 'background 0.2s, opacity 0.2s'
                                    }}>
                                      {isValidating ? (
                                        <>
                                          <svg width="18" height="18" viewBox="0 0 50 50" style={{ marginRight: 7 }}>
                                            <circle cx="25" cy="25" r="20" stroke="#a21caf" strokeWidth="5" fill="none" strokeDasharray="31.4 31.4" strokeDashoffset="0">
                                              <animateTransform attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.8s" repeatCount="indefinite" />
                                            </circle>
                                          </svg>
                                          Validating...
                                        </>
                                      ) : 'Upload'}
                                    </span>
                                  </label>
                                </div>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                  </div>
                </div>
              ) : (
                <div style={{ color: '#a21caf', marginBottom: 24 }}>No document requirements found for this visa. Please try another selection.</div>
              )}
              <div style={{ textAlign: 'center', marginTop: 16 }}>
                {error && (
                  <div style={{ color: '#dc2626', marginBottom: 12 }}>{error}</div>
                )}
                {/* Removed submit button, upload is now automatic on file select */}
                {submitted && (
                  // Display the upload response message
                  <span style={{ color: '#22c55e', fontWeight: 600 }}>{uploadResponseMsg}</span>
                )}
                {progress < 100 && Array.isArray(docList) && docList.length > 0 && (
                  <span style={{ color: '#a21caf', display: 'block', marginTop: 8 }}>Please upload all required documents to continue.</span>
                )}
                {/* Next button below table, enabled only when all documents are uploaded */}
                {Array.isArray(docList) && docList.length > 0 && step === 3 && !applicationDetails && (
                  <button
                    type="button"
                    className="inspired-btn"
                    disabled={progress < 100 || submittingDoc !== null || loadingApplicationDetails}
                    style={{ width: '100%', marginTop: 24 }}
                    onClick={handleApplicationDetails}
                  >
                    {loadingApplicationDetails ? (
                      <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#a21caf' }}>
                        <svg width="22" height="22" viewBox="0 0 50 50" style={{ marginRight: 8 }}>
                          <circle cx="25" cy="25" r="20" stroke="#a21caf" strokeWidth="5" fill="none" strokeDasharray="31.4 31.4" strokeDashoffset="0">
                            <animateTransform attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.8s" repeatCount="indefinite" />
                          </circle>
                        </svg>
                        Application Overview...
                      </span>
                    ) : 'Application Overview'}
                </button>
                )}
                {/* Show application details table as step 4, replacing the whole view */}
                {step === 4 && applicationDetails && (
                  <div style={{ marginTop: 32, textAlign: 'center' }}>
                    <h2 style={{ color: '#2563eb', fontWeight: 700, marginBottom: 24 }}>Application Overview</h2>
                    <table style={{ margin: '0 auto', minWidth: 340, borderCollapse: 'collapse', boxShadow: '0 2px 8px rgba(30,41,59,0.08)' }}>
                      <thead style={{ background: '#f3f4f6' }}>
                        <tr>
                          <th style={{ padding: '12px 18px', borderBottom: '2px solid #a21caf', fontWeight: 600, fontSize: '1.05rem', color: '#334155', textAlign: 'left' }}>Field</th>
                          <th style={{ padding: '12px 18px', borderBottom: '2px solid #a21caf', fontWeight: 600, fontSize: '1.05rem', color: '#334155', textAlign: 'left' }}>Value</th>
                        </tr>
                      </thead>
                      <tbody>
                        {applicationDetails.map(({ key, value }, idx) => (
                          <tr key={idx} style={{ background: idx % 2 === 0 ? '#fafafc' : '#f3f4f6' }}>
                            <td style={{ padding: '12px 18px', borderBottom: '1px solid #e5e7eb', fontWeight: 500, color: '#334155', textAlign: 'left' }}>{key}</td>
                            <td style={{ padding: '12px 18px', borderBottom: '1px solid #e5e7eb', color: '#475569', textAlign: 'left' }}>{value}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

export default VisaAgent;
